<template>
    <basicSearch :onSearchApi="onSearchApi" placeholder="搜索赛季" v-bind="$attrs" v-on="$listeners"></basicSearch>
</template>

<script>

import basicSearch from '@/components/basic/search.vue';
import { searchSeason } from '@/api/ballsports/base/season';


export default {
    name: "season-search",
    components: {
        basicSearch
    },
    data () {
        return {
            onSearchApi: searchSeason,
        }
    }
}
</script>
